<style scoped="scoped" lang="scss">
.expand-json {
	max-height: 300px;
	overflow: auto;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/in/out/log/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('jiekoumingcheng')">
            <el-input v-model="yt.conditions.interfaceName"></el-input>
          </el-form-item>
          <el-form-item :label="$t('diaoyongzhuangtai')">
            <yi_dictionary_select :max="999" clearable type="INTERFACE_LOG_STATUS" :ids.sync="yt.conditions.status"> </yi_dictionary_select>
          </el-form-item>
          <el-form-item :label="$t('fanhuixinxi')">
            <el-input v-model="yt.conditions.interfaceReturnInfo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('chuangjianshijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.startTime" :end.sync="yt.conditions.endTime"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(conditions)">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 自定义某个字段 -->
      <template #fanhuixinxi="scope">
        <div @click="expandJson(scope.row)">
          <pre class="expand-json">{{ scope.row.interfaceReturnInfo }}</pre>
        </div>
      </template>
      <template #canshu="scope">
        <div @click="expandJsonParam(scope.row)">
          <pre class="expand-json">{{ scope.row.interfaceParams }}</pre>
        </div>
      </template>
      <template #chulijieguo="scope">
        <div @click="expandJson(scope.row)">
          <pre class="expand-json">{{ scope.row.resultData }}</pre>
        </div>
      </template>
      <template #xiangyingshijian="scope">
       {{scope.row.responseTime != null ? (scope.row.responseTime / 1000).toFixed(1) + 's':''}}
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_customize_standard_interface_log_list',
  data() {
    return {
      exportLoading: false,
      selectRows: [],
      conditions: {
        startTime: this.dayjs()
          .startOf('month')
          .valueOf(),
        endTime: this.dayjs()
          .endOf('month')
          .valueOf()
      },
      columns: [
        {
          label: 'jiekoutigongfang',
          prop: 'apiProvider',
          width: 130
        },
        {
          label: 'jiekoudiaoyongfang',
          prop: 'apiCaller',
          width: 130
        },
        {
          label: 'jiekoumingcheng',
          prop: 'interfaceName',
          width: 180
        },
        {
          label: 'diaoyongzhuangtai',
          type: 'tag',
          prop: 'status',
          width: 130,
          tags: {
            '0': {
              color: '#67c23a',
              text: this.$t('chenggong')
            },
            '1': {
              color: '#f78989',
              text: this.$t('shibai')
            }
          }
        },
        {
          label: 'canshu',
          prop: 'interfaceParams',
          type: 'slot',
					wrap: true
        },
        {
          label: 'fanhuixinxi',
          prop: 'interfaceReturnInfo',
          type: 'slot',
					wrap: true
        },
        {
				label: 'chulijieguo',
				prop: 'resultData',
        type: 'slot',
					wrap: true
			},
        {
				label: 'xiangyingshijian',
				prop: 'responseTime',
        type: 'slot',
        width: 80,
        wrap: true
			},
        {
          label: 'chuangjianren',
          prop: 'createByObject.nickname',
          width: 130
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time',
          width: 160
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = this.utils.copy(this.conditions);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    // 展开json
    expandJson(row) {
      try {
        if (row.interfaceReturnInfo === 'null') {
          return;
        }
        const info = JSON.parse(row.interfaceReturnInfo);
				row.interfaceReturnInfo = info;
      } catch (err) {
        console.warn('解析json异常', err);
      }
    },
    expandJsonParam(row) {
      try {
        if (row.interfaceParams === 'null') {
          return;
        }
        const info = JSON.parse(row.interfaceParams);
				row.interfaceParams = info;
      } catch (err) {
        console.warn('解析json异常', err);
      }
    },
  }
};
</script>
